"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createFromIconfont;

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("./index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customCache = new Set();

function createFromIconfont(scriptUrl) {
  /**
   * DOM API required.
   * Make sure in browser environment.
   * The Custom Icon will create a <script/>
   * that loads SVG symbols and insert the SVG Element into the document body.
   */
  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    script.setAttribute('data-namespace', scriptUrl);
    customCache.add(scriptUrl);
    document.body.appendChild(script);
  }

  var Iconfont = function Iconfont(props) {
    Iconfont.displayName = 'Iconfont';
    var type = props.type;
    var content;

    if (type) {
      content = _react.default.createElement("use", {
        xlinkHref: "#".concat(type)
      });
    }

    return _react.default.createElement(_index.default, props, content);
  };

  return Iconfont;
}